
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAlertHeaderAggregatedIec as ObiAlertHeaderAggregatedIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-alert-header-aggregated-iec.js';
 
 
 

 
 export const ObiAlertHeaderAggregatedIec = createComponent({
   react: React,
   tagName: 'obi-alert-header-aggregated-iec',
   elementClass: ObiAlertHeaderAggregatedIecElement,
   events: {
     
   }
  });
 
 